import React from "react";
import { Component } from "react";
import { Switch } from "react-router-dom";
import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation, getObject, loremGenerator, setObject, translate } from "../../utils/useful";
import LoaderButton from "../LoaderButton";
// import TextComponentFloatConfig from "./TextComponentFloatConfig";
// import React, { useRef, useState } from "react";
import tableComponents from '../tableComponents'
import HttpServices from "../../utils/Http.services";
import Loader from 'react-loader-spinner'
import { nanoid } from "nanoid";
import TextEditorInput from "./TextEditorInput";
import { changeSelectedTextEffects } from "../../variables/notebook";
import CardBuilderAddElement from "../CardBuilderAddElement";
import ComponentFloatConfig from "./ComponentFloatConfig";
import PageBuilderMain from "../../windows/PageBuilderMain";
import { FormBuilderObjects, formBuilderGroups } from "../../variables/formBuilderData";
import WidgetComponents from "../widgets/WidgetComponents";
import { widgetsGroups, widgetsList } from "../../variables/widgetsList";

class CardBuilder extends Component {
  state = {
    selectedElement: {},
    cardInfo: {},
    fakeData: {},
    elements: [],
    type: 'dashboard',
    componentsInfo: {
      form: { object: FormBuilderObjects, groups: formBuilderGroups, components: tableComponents },
      dashboard: { object: widgetsList, groups: widgetsGroups, components: WidgetComponents },

    },
  };


  componentDidMount() {

    // console.log(this.props.headers)
    // console.log('this.props.headers2', this.props.headers)
    // console.log('this.props.builderHeaders1', this.props.builderHeaders)
    if (this.props.headers && !this.props.builderHeaders) {

      this.init()
      // this.setFields(this.props.cardHeaders)
    } else {
      this.getFields()
    }

    this.setState({ initData: this.props.data })
  }

  componentDidUpdate(prevProps) {
    // if (!this.props.cardHeaders && (JSON.stringify(this.props.fullData?.collection) != JSON.stringify(prevProps.fullData?.collection))) {
    //   this.getFields(this.props.fullData?.collection)
    // }
    let frame = this.props.header?.information?.frame
    if (frame) {
      frame = JSON.stringify(frame)
    }

    let paramFrames = this.state.paramFrames
    if (paramFrames) {
      paramFrames = JSON.stringify(paramFrames)
    }

    if (frame != paramFrames) {


      this.getFields(this.props.header?.information?.frame)
    }

    // console.log(this.props.data)
    if (this.props.data != prevProps.data) {
      this.setState({ initData: this.props.data })

      // this.setState({ elements: this.props.data, updatedElements: this.props.data })
    }
  }



  init() {

    let params = this.props.params ? JSON.parse(JSON.stringify(this.props.params)) : []


    let param = { label: "Current Record", value: '*record', fields: this.props.headers, info: this.props.currentFrame }


    params.splice(0, 0, param)

    // console.log(this.props.headers)
    // console.log(params)


    this.setState({ frame: this.props.currentFrame, params, fields: this.props.headers, elements: this.props.data, updatedElements: this.props.data })


  }


  updateElement = (key, value, extra) => {

    // console.log("updateElement")
    // console.log(value)
    let index = extra?.index

    let elements = JSON.parse(JSON.stringify(this.state.updatedElements))

    // console.log(index)
    // console.log(elements)


    if (index == null) {
      this.props.changeValue(this.props.header.key, elements, this.props.extra)
      return
    }
    if (elements[index]) {

      setObject(elements[index], key, value)
      // console.log(elements)
      this.props.changeValue(this.props.header.key, elements, this.props.extra, null, true)

    }

  }

  onDragStartAction = (e) => {
    this.PageBuilderMain.onDragStartAction(e)
  }

  getFields = (frames) => {

    // console.log("getFields", frames)

    this.setState({ paramFrames: frames })

    // console.log(this.props.fullData)
    // console.log(this.props.headers)

    // let collection = this.props.fullData?.collection

    let body = { filter: {} }
    let myFrames = []
    if (!Array.isArray(frames)) {
      myFrames = [frames?._id ?? frames]
    } else {
      frames.forEach(element => {
        myFrames.push(element._id ?? element)
      });
    }

    body.filter._id = myFrames
    // console.log("getFields")
    // console.log(this.props.fullData)
    if (frames) {
      this.setState({ isLoadingHeaders: true })
      // let body = { collection }
      // console.log(body)
      // console.log("getFrame!!", body)

      // if (body.filter._id?.length > 0) {

      HttpServices.request('getFrames', body, (fetchResult, fetchError) => {


        this.setState({ isLoadingHeaders: false })
        if (fetchError) {
          this.setState({ fetchError })
          return
        }

        // let fields = fetchResult?.info?.fields

        // console.log(this.props.data)

        let params = this.props.params ? JSON.parse(JSON.stringify(this.props.params)) : []


        let myParams

        // console.log("SKSSJKQDK")
        if (Array.isArray(fetchResult.info)) {
          fetchResult.info.forEach(frame => {
            if (!myParams) {
              myParams = { label: "Current Record", value: '*record', fields: frame?.fields, info: fetchResult.info }
            } else {
              // myParams.fields = [...(myParams.fields ?? []), ...(frame?.fields ?? [])]

              if (Array.isArray(frame?.fields)) {
                frame.fields.forEach(frameField => {
                  let found = false
                  let myParamsFields = myParams.fields ?? []


                  myParamsFields.forEach(paramField => {

                    // console.log(paramField)
                    if (frameField.information?.label == paramField.information?.label) {
                      found = true
                    }
                  });

                  // console.log("found", frameField.type, found)

                  if (!found && !frameField.type.startsWith('"Static')) {
                    myParams.fields.push(frameField)
                  }

                })
              }


            
            }
          });
        }


        let foundId = false
                            
        for (let a = 0; a < myParams.fields.length; a++) {
            const element = myParams.fields[a];
            if (element?.key == '_id') {
                foundId = true
            }
        }

        if (!foundId) {
            myParams.fields.splice(0, 0, { key: '_id', type: 'TextInput', information: { label: '{{lang}}ID', placeholder: '{{lang}}ID' } })
            myParams.fields.push({ key: 'cDate', type: 'DateInput', information: { label: '{{lang}}Creation date', } })
            myParams.fields.push({ key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Update date', } })
        }
       
        // let param = { label: "View Record", value: 'record', fields: fetchResult.info?.fields, info: fetchResult.info }
        // console.log("myParams",myParams)
        if (myParams) {
          params.splice(0, 0, myParams)
        }

        // console.log("params",params)
        // if (this.props.data) {

        this.setState({ frame: fetchResult?.info, params, fields: fetchResult?.info.fields, elements: this.props.data, updatedElements: this.props.data })

        // } else {
        //   // this.setFields(fields)
        // }

      })
      // }
    }
  }






  setFields = (fields) => {
    let fakeData = {}
    let cardInfo = this.props.view?.settings?.cardInfo

    if (!cardInfo) {
      cardInfo = {}
    }


    let elements = this.state.elements

    // console.log("setFields")


    if (Array.isArray(fields)) {

      fields.forEach(field => {

        let data

        if (field.type != "DateInput" && field.type != "PriceInput" && field.type != "NumberInput") {
          data = field.information?.label
        } else {
          data = loremGenerator(field.type)
        }


        // console.log(data)
        fakeData[field.key] = data

        let content = "<span>" + field.information?.label + ': ' + '{{' + field.information?.label + '}} </span>'
        let id = nanoid()
        let element = { id, key: 'data', type: 'TextEditorInput', data: content, field }

        elements.push(element)
      })
    }

    // console.log(headers)
    // console.log(fakeData)


    this.setState({ cardInfo, fakeData, elements, updatedElements: elements }, () => {
      this.updateElement()
    })
  }



  addElement = (item) => {
    let elements = this.state.elements

    // console.log(item)
    let id = nanoid()
    let element = { id, key: 'data', type: item.key, information: item.information }


    elements.push(element)

    this.setState({ elements })
  }





  getInfo = () => {
    return this.PageBuilderMain.state.content

  }


  onDragEnd = (result) => {
    let items = Array.from(this.state.updatedElements);
    let [reorderItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderItem);

    this.setState({ elements: items, updatedElements: items }, () => {
      this.updateElement()
    })

    if (this.props.onSortChange) {
      this.props.onSortChange(items)
    }
  }

  // onDragEnd = (result) => {
  //   let items = Array.from(this.props.visibleKeys);
  //   let [reorderItem] = items.splice(result.source.index, 1);
  //   items.splice(result.destination.index, 0, reorderItem);

  //   if (this.props.onSortChange) {
  //     this.props.onSortChange(items)
  //   }
  // };

  setSelected = (header) => {
    this.setState({ selectedElement: this.state.selectedElement?.id == header.id ? null : header })
  }

  setElementSettings = (index, key, value) => {
    let elements = this.state.elements

    if (elements[index]) {
      setObject(elements[index], key, value)
    }
    // console.log('elements', elements)
    this.setState({ elements })
  }

  setData = (headerKey, key, value) => {
    let cardInfo = this.state.cardInfo
    cardInfo[headerKey] = cardInfo[headerKey] ?? {}
    cardInfo[headerKey][key] = value

    // console.log(cardInfo)
    this.setState({ cardInfo })
  }

  updateTextEffectsStyleStatus = () => {

  }

  makeInvisible = (key, index) => {

    let elements = this.state.elements
    elements.splice(index, 1)

    this.setState({ elements })

    if (this.props.makeInvisible) {
      this.props.makeInvisible(key, index)
    }
  }



  cardLiveChange = () => {

    // console.log("cardLiveChange")
    if (this.PageBuilderMain) {
      let content = this.PageBuilderMain?.state?.content

      // if (JSON.stringify(content) != JSON.stringify(this.props.data))
      // console.log(this.props.changeValue)
      // console.log("OK")
      if (this.props.changeValue) {
        this.props.changeValue(this.props.header?.key, content, this.props.extra)
      }
    }
  }


  render() {


    return (



      <div className="px-2  pb-3 br-6 position-relative" style={{ backgroundColor: "#f2f2f2" }}
      // onClick={() => { if (this.state.selectedElement != null) this.setState({ selectedElement: null }) }}
      >

        {/* <button className="mb-2">
          + Insert
        </button> */}

        <div className="mb-2 pt-2" style={{ position: 'sticky', top: 50, zIndex: 3 }}>
          <CardBuilderAddElement onDragStart={this.onDragStart} colors={this.props.colors} params={this.state.params} fields={this.state.frame?.fields} addElement={this.addElement} onDragStartAction={this.onDragStartAction} />
        </div>
        <div className="br-10 shadow-1 " style={{ backgroundColor: '#fff' }}>
          {/* <div className="px-3 pt-3 mb-2">
            <img className="w-100" src="/cover.jpg" style={{ borderRadius: '10px 10px 10px 10px', aspectRatio: '5/3', objectFit: 'cover' }} />
          </div> */}

          {/* {this.props.visibleFields?.length == 0 && (
            <div className="px-3 ">
              <p className="text-smaller color-gray-1">{translate("No field is added to the card. From the fields list blow, click on make visible to add it to the card view.")}</p>
            </div>
          )} */}

          <div className="">


            {this.state.isLoadingHeaders && (
              <div className="w-100 flexcc">
                <Loader
                  type={"Grid"}
                  color={"#000000aa"}
                  height={30}
                  width={30}
                />
              </div>
            )}
            <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.setPositionDiv = el)}></div>

            <PageBuilderMain baseUrl={this.props.baseUrl} windowData={this.props.windowData} functionsHandler={this.props.functionsHandler} setHeader={this.props.setHeader} changeWindow={this.props.changeWindow} initData={this.state.initData} params={this.state.params} type={this.state.type} componentsInfo={this.state.componentsInfo[this.state.type]} ref={el => this.PageBuilderMain = el} width={this.props.width} height={this.props.height} colors={this.props.colors} changeWindowLink={this.props.changeWindowLink} changePage={this.props.changePage} pageChangePage={this.props.pageChangePage} applet={this.props.applet} liveChange={this.cardLiveChange} editMode={true} noScroll={true} fields={this.state.fields} cardMode={true} variables={this.props.variables} padding={'5px 5px'} />



            {/* <div className="mb-2 position-relative">
              <p className="" style={{ fontSize: 13, color: '#555' }}>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quod vitae quidem quas esse ab, asperiores, in possimus magnam exercitationem fugit soluta impedit. Illum itaque ex nihil excepturi veritatis nulla delectus!</p>



            </div> */}




          </div>
        </div>
      </div>

    );
  }
}

export default CardBuilder;
